// extracted by mini-css-extract-plugin
export default {"p_tye":"d2632cdee8","slcted":"_19c4399c91","slc_color":"a7e9a873eb","item_p":"f354c102d8","r0":"bab2b8a763"};